/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdmnistrativeAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type AdmnistrativeAreasQuery = { administrative_area: Array<{ area: string }> };


export const AdmnistrativeAreasDocument = /*#__PURE__*/ gql`
    query AdmnistrativeAreas {
  administrative_area(order_by: {area: asc}, where: {level: {_eq: 2}}) {
    area
  }
}
    `;

/**
 * __useAdmnistrativeAreasQuery__
 *
 * To run a query within a React component, call `useAdmnistrativeAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmnistrativeAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdmnistrativeAreasQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdmnistrativeAreasQuery(baseOptions?: Apollo.QueryHookOptions<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>(AdmnistrativeAreasDocument, options);
      }
export function useAdmnistrativeAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>(AdmnistrativeAreasDocument, options);
        }
// @ts-ignore
export function useAdmnistrativeAreasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>): Apollo.UseSuspenseQueryResult<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>;
export function useAdmnistrativeAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>): Apollo.UseSuspenseQueryResult<AdmnistrativeAreasQuery | undefined, AdmnistrativeAreasQueryVariables>;
export function useAdmnistrativeAreasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>(AdmnistrativeAreasDocument, options);
        }
export type AdmnistrativeAreasQueryHookResult = ReturnType<typeof useAdmnistrativeAreasQuery>;
export type AdmnistrativeAreasLazyQueryHookResult = ReturnType<typeof useAdmnistrativeAreasLazyQuery>;
export type AdmnistrativeAreasSuspenseQueryHookResult = ReturnType<typeof useAdmnistrativeAreasSuspenseQuery>;
export type AdmnistrativeAreasQueryResult = Apollo.QueryResult<AdmnistrativeAreasQuery, AdmnistrativeAreasQueryVariables>;